import { Controller } from "@hotwired/stimulus";

// Mounted on .filter-chips. Chip × and Clear all buttons are inside this
// element, but the navigation logic lives on the sibling filter-drawer
// controller. Both methods read state the drawer controller has (leads URL,
// segment_origin/anchor/target_event_id preservation) — so we delegate via
// outlet rather than duplicating the URL-building helpers.
export default class extends Controller {
  static outlets = ["filter-drawer"];

  removeFilter(event) {
    if (this.hasFilterDrawerOutlet) this.filterDrawerOutlet.removeFilter(event);
  }

  clearAll(event) {
    if (this.hasFilterDrawerOutlet) this.filterDrawerOutlet.clearAll(event);
  }

  // LRPO-5153 — "Compared with <event>" chip ×. Drops target_event_id while
  // preserving the rest of the applied filter state, navigating off the clean
  // leads base (no DataTables params, never the JSON endpoint).
  removeCompare(event) {
    if (this.hasFilterDrawerOutlet) this.filterDrawerOutlet.removeCompare(event);
  }
}
